module.exports = __webpack_public_path__ + "assortment-analysis.svg?f6dcc1b10def7643e8632ae1dea82670";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/assortment-analysis.svg
// module id = 276
// module chunks = 2